import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/fr';

export default () => {
  moment.locale(navigator.language);
  return moment().format('LL');
};
